// This file is updated with the version on build
// Don't edit unless you are sure what you are doing
import { WindowKeys } from "@omni/components/services/windowManagement";
import * as WindowManagement from "@omni/components/services/windowManagement";

WindowManagement.saveObject(WindowKeys.VERSION, "9.0.7");
